import React from 'react';
import { element, string } from 'prop-types';
import mappings from './Typography.style';

const Typography = ({ variant = 'h2', children = undefined }) => {
  const Component = mappings[variant.toUpperCase()];

  return <Component>{children}</Component>;
};

Typography.propTypes = {
  children: element.isRequired,

  variant: string.isRequired,
};

export default Typography;
